import { getRequest } from '../services/requestHandler';
import { Nationality } from '../models';

export const getNationalities = async () => {
  const url = `player/GetNationalities?orderBy=sortId&activeOnly=true`;
  const response = await getRequest<Nationality>('GetNationalities', url);
  return response;
};
